import {
  HttpEvent,
  HttpInterceptorFn,
  HttpResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';
import { AchievementNotificationService } from '../services/achievement-notification/achievement-notification.service';
import { Achievement } from '../../pages/achievements/models/achievements';

export const achievementInterceptor: HttpInterceptorFn = (req, next) => {
  const achievementNotificationService = inject(AchievementNotificationService);

  return next(req).pipe(
    tap((event: HttpEvent<unknown>) => {
      if (
        event instanceof HttpResponse &&
        event.body &&
        typeof event.body === 'object'
      ) {
        const body = event.body as Record<string, unknown>;
        const unlocked = body['unlocked_achievements'];
        if (Array.isArray(unlocked) && unlocked.length > 0) {
          achievementNotificationService.showUnlockedAchievements(
            unlocked as Achievement[],
          );
        }
      }
    }),
  );
};
